$('[data-fancybox]').fancybox({
	infobar: false,
	buttons: ['close'],
	hideScrollbar: false,
	wheel: false,
});
